<template>
	<m-card :max-width="maxWidth">
		<m-card-title>{{ title }}</m-card-title>
		<hr />
		<MultipleBarChartSimple :options="options" />
	</m-card>
</template>

<script>
export default {
	props: {
		options: {
			type: Object,
			default: () => {
				return {}
			}
		},
		maxWidth: {
			type: Number,
			default: 0
		},
		title: {
			type: String,
			default: ''
		}
	}
}
</script>
